import { makeConstantFactory } from 'utils/constantsHelper'

const makeConstant = makeConstantFactory('segment')

export const FETCH_SEGMENT_LIST = makeConstant('FETCH_SEGMENT_LIST')
export const FETCH_SEGMENT_LIST_PENDING = makeConstant('FETCH_SEGMENT_LIST_PENDING')
export const FETCH_SEGMENT_LIST_FAILED = makeConstant('FETCH_SEGMENT_LIST_FAILED')
export const RECEIVE_SEGMENT_LIST = makeConstant('RECEIVE_SEGMENT_LIST')

export const FETCH_SEGMENT_SET_CARDINALITY = makeConstant('FETCH_SEGMENT_SET_CARDINALITY')
export const FETCH_SEGMENT_SET_CARDINALITY_PENDING = makeConstant('FETCH_SEGMENT_SET_CARDINALITY_PENDING')
export const FETCH_SEGMENT_SET_CARDINALITY_FAILED = makeConstant('FETCH_SEGMENT_SET_CARDINALITY_FAILED')
export const FETCH_SEGMENT_SET_CARDINALITY_SUCCESS = makeConstant('FETCH_SEGMENT_SET_CARDINALITY_SUCCESS')

export const FETCH_END_USER_MEMBERSHIP = makeConstant('FETCH_END_USER_MEMBERSHIP')
export const FETCH_END_USER_MEMBERSHIP_PENDING = makeConstant('FETCH_END_USER_MEMBERSHIP_PENDING')
export const FETCH_END_USER_MEMBERSHIP_FAILED = makeConstant('FETCH_END_USER_MEMBERSHIP_FAILED')
export const FETCH_END_USER_MEMBERSHIP_SUCCESS = makeConstant('FETCH_END_USER_MEMBERSHIP_SUCCESS')



// WEBPACK FOOTER //
// ./src/scripts/app/modules/segment/constants.js